import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { dashboardChartPath } from "../../services/config";
import axios from "axios";
import { config } from "../../services/configHeader"

const baseUrl = process.env.REACT_APP_BASE_URI;
// const config = {
//   headers: {
//     "Content-Type": "application/json",
//     Authorization: `Bearer 7fa5d115dbbf825a0a4abb2b2a7f37de`,
//   },
// };

const user = JSON.parse(localStorage.getItem("user_data")) || {};
const accountType = user?.account_type;

export const getChartData = createAsyncThunk("getChartData", async (body) => {
  const result = {
    data: {
      message: "Sorry, you can only view the data, not create it.",
      data: [],
    },
  };

  return parseInt(accountType) === 2
    ? result
    : await axios
        .post(`${baseUrl}${dashboardChartPath}`, body, config)
        .then((response) => {
          return response;
        })
        .catch((error) => {
            let data = {}
          if (!navigator.onLine) {
            alert("You are offline. Please check your internet connection.");
          } else {
            data.data = error.response.data
            data.status = error.response.status
          }
          return data;
        });
});

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    chartLoading: false,
    chartSuccess: false,
    chartError: false,
    chartMessage: null,
    chartData: null,
  },
  reducers: {
    initChartStatus: (state) => {
      state.chartLoading = false;
      state.chartSuccess = false;
      state.chartError = false;
      state.chartMessage = null;
      state.chartData = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getChartData.pending, (state, action) => {
      state.chartLoading = true;
      state.chartSuccess = false;
      state.chartError = false;
      state.chartMessage = null;
      state.chartData = null;
    });
    builder.addCase(getChartData.fulfilled, (state, action) => {
      const status = action.payload.status;
      if (status === 200 || status === "200") {
        if (
          action.payload.data.status === true ||
          action.payload.data.status === "true"
        ) {
          state.chartLoading = false;
          state.chartSuccess = true;
          state.chartError = false;
          state.chartMessage = action.payload.data.message;
          state.chartData = action.payload.data.data;
        } else {
          state.chartLoading = false;
          state.chartSuccess = false;
          state.chartError = true;
          state.chartMessage = action.payload.data.message;
          state.chartData = null;
        }
      } else {
        state.chartLoading = false;
        state.chartSuccess = false;
        state.chartError = true;
        state.chartMessage = action.payload.data.message;
        state.chartData = null;
      }
    });
    builder.addCase(getChartData.rejected, (state, action) => {
      state.chartLoading = false;
      state.chartSuccess = false;
      state.chartError = true;
      state.chartMessage = action.payload.data.message;
      state.chartData = null;
    });
  },
});

export const { initChartStatus } = dashboardSlice.actions;
export default dashboardSlice.reducer;
